import React from 'react';
import { useProfileWhatsAppAccountCreateModel } from './model';
import { ProfileWhatsAppAccountCreateView } from './view';

export const ProfileWhatsAppAccountCreateWidget: React.FC = () => {
  const {
    state,
    submit,
    confirmSubmit,
    cancelConfirm,
    switchMode,
    resetDraft,
  } = useProfileWhatsAppAccountCreateModel();

  return (
    <ProfileWhatsAppAccountCreateView
      state={state}
      onSubmit={submit}
      onConfirmSubmit={confirmSubmit}
      onCancelConfirm={cancelConfirm}
      onSwitchMode={switchMode}
      onResetDraft={resetDraft}
    />
  );
};
